<script setup lang="ts">
import { onBeforeMount, ref, computed } from 'vue';
import { getCurrentLocale } from '@/i18n';
import { useComponentComposable } from '@/components/useComponentComposable';
import Checkbox from 'primevue/checkbox';

interface Props {
  listDayOfWeek: number[];
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:listDayOfWeek': [value: any] }>();

const currentLanguage = getCurrentLocale();
const { getFirstCharacterOfDay } = useComponentComposable();
const days = ref<string[]>([]);
const dayOfWeek = ref<any>();

const listDayOfWeek = computed({
  get() {
    return props.listDayOfWeek;
  },
  set(value) {
    emits('update:listDayOfWeek', value);
  }
});

const renderDayOfWeek = () => {
  return days.value.map((day: string, index: number) => {
    return {
      label: day,
      value: !!listDayOfWeek.value[index]
    };
  });
};

const renderValueEmit = (data: any) => {
  return data.map((day: any) => {
    return day.value ? 1 : 0;
  });
};

const updateValue = () => {
  emits('update:listDayOfWeek', renderValueEmit(dayOfWeek.value));
};

onBeforeMount(() => {
  days.value = getFirstCharacterOfDay(currentLanguage);
  dayOfWeek.value = renderDayOfWeek();
});
</script>
<template>
  <div class="seasonal-list w-full">
    <p class="mb-1">{{ $t('common.labels.day_of_week') }}</p>
    <div class="flex gap-2 justify-content-between">
      <div v-for="(day, index) of dayOfWeek" :key="index" class="flex flex-column align-items-center">
        <p class="mb-0">
          {{ day.label }}
        </p>
        <Checkbox class="seasonal_day" :binary="true" v-model="day.value" @update:modelValue="updateValue()" />
      </div>
    </div>
  </div>
</template>
